import ModalComponent from '@/components/Modal/Modal.vue';
import ModalWithoutApplicationComponent from '@/components/ModalWithoutApplication/ModalWithoutApplication.vue';
import ModalErrorComponent from '@/components/ModalError/ModalError.vue';
import ModalNetworkError from '@/components/ModalNetworkError/ModalNetworkError.vue';
import transferTracking from '@/api/transferTracking';
import recaptcha from '@/api/recaptcha';

export default {
  name: 'Home',
  components: {
    ModalComponent,
    ModalWithoutApplicationComponent,
    ModalErrorComponent,
    ModalNetworkError,
  },
  data() {
    return {
      name: '',
      isLoading: false,
      inputRut: '',
      inputError: '',
      showModal: false,
      showModalWithoutApplication: false,
      showModalError: false,
      showModalNetworkError: false,
      result: null,
      captchaValidation: false,
      captchaError: '',
      captchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
    };
  },
  computed: {
    isFormIncomplete() {
      return (!this.inputRut || !!this.inputError || !this.captchaValidation);
    },
  },
  mounted() {
    this.registerRecaptchaCallbacks();
    this.loadRecaptcha();
  },
  beforeDestroy() {
    delete window.onRecaptchaSuccess;
    delete window.onRecaptchaExpired;
    delete window.onRecaptchaError;
  },
  methods: {
    getError(err) {
      this.inputError = err;
    },
    registerRecaptchaCallbacks() {
      window.onRecaptchaSuccess = token => this.verifyCaptcha(token);
      window.onRecaptchaExpired = () => this.expireCaptcha();
      window.onRecaptchaError = () => this.handleCaptchaError('reCAPTCHA no pudo validar tu respuesta.');
    },
    loadRecaptcha() {
      if (document.getElementById('recaptcha-enterprise')) {
        return;
      }
      const script = document.createElement('script');
      script.id = 'recaptcha-enterprise';
      script.src = 'https://www.google.com/recaptcha/enterprise.js';
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        this.captchaError = 'No se pudo cargar reCAPTCHA. Verifica tu conexión a internet.';
      };
      document.head.appendChild(script);
    },
    async verifyCaptcha(token) {
      this.captchaError = '';
      try {
        const response = await recaptcha.verifyCaptcha(token);
        if (response.success && token) {
          this.captchaValidation = true;
          return;
        }
        this.handleCaptchaError();
      } catch (error) {
        if (this.isRateLimitError(error)) {
          this.handleCaptchaError(error.response.data.message);
          return;
        }
        this.handleCaptchaError();
      }
    },
    isRateLimitError(error) {
      const response = error && error.response;
      const data = response && response.data;
      const code = data && data.code;
      return code === 'RECAPTCHA_RATE_LIMIT' && response.status === 429;
    },
    handleCaptchaError(message) {
      this.captchaValidation = false;
      this.captchaError = message || 'No pudimos validar tu captcha. Intenta nuevamente.';
      this.resetCaptcha();
    },
    expireCaptcha() {
      this.captchaValidation = false;
      this.captchaError = '';
      this.resetCaptcha();
    },
    resetCaptcha() {
      const { grecaptcha } = window;
      if (grecaptcha && grecaptcha.enterprise) {
        grecaptcha.enterprise.reset();
      }
    },
    async getData() {
      this.isLoading = true;
      try {
        const status = await transferTracking.getStatus(this.formatRut(this.inputRut));
        this.handleTransferStatusSuccess(status);
      } catch (error) {
        this.handleTransferStatusError();
      } finally {
        this.inputRut = '';
        this.captchaValidation = false;
        this.resetCaptcha();
        this.isLoading = false;
      }
    },
    formatRut(rut) {
      if (rut.includes('-')) {
        return rut;
      }

      return `${rut.substring(0, rut.length - 1)}-${rut.substring(rut.length - 1)}`;
    },
    handleTransferStatusSuccess(status) {
      const { message } = status;
      switch (message) {
        case 'NoTransferRequestsFound':
          this.showModalWithoutApplication = true;
          return;
        case 'ElectronicTransferRejected':
        case 'ElectronicTransferError':
          this.showModalError = true;
          this.name = status.clientName;
          return;
        case 'ElectronicTransferSuccessful':
        case 'ElectronicTransferAccepted':
          this.showStepsModal(status);
          return;
        default:
          this.showModalError = true;
          this.name = status.clientName;
      }
    },
    handleTransferStatusError() {
      this.showModalNetworkError = true;
    },
    showStepsModal(status) {
      this.result = status;
      this.name = status.clientName;
      this.inputRut = '';
      let stepsQuantity = 0;

      if (this.result.requestSteps.length > 0) {
        this.result.requestSteps.forEach((step) => {
          if (step.stepPassed) {
            stepsQuantity += 1;
          }
        });
      }

      if (stepsQuantity === 0) {
        this.showModalError = true;
      } else {
        this.showModal = true;
      }
    },
    closeModal() {
      this.showModal = false;
      this.showModalError = false;
      this.showModalWithoutApplication = false;
      this.showModalNetworkError = false;
      this.name = '';
      this.result = null;
    },
  },
};
